import React from "react";
import { Spinner, Container, Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleInfo,
  faDeleteLeft,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import Header from "../../Common/Header";
import useCandidateSuggestedJobs from "./useCandidateSuggestedJobs";
import JobCard from "./_components/JobCard";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation } from "swiper";
import { CountrySearchDropdown } from "../../../_uiComponents/Search/CountrySearchDropdown";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import { EXPERIENCE_TYPE, EMPLOYMENT_TYPE } from "./constants";
import MainLayout from "../../Common/MainLayout";
export default function CandidateSuggestedJobs(props) {
  const {
    userMetaData,
    loading,
    allJobs,
    skillsListLoading,
    suggestedJobsLoading,
    skillsTagsAdded,
    selectedSkill,
    showSearch,
    searchInputRef,
    jobSearch,
    candidateSelectedEmployment,
    candidateSelectedSkill,
    onSearch,
    onSearchInputChange,
    setLastElement,
    onJobApplyClick,
    onJobsSkillUnselectClick,
    onJobsSkillsChange,
    onViewAppliedJobsClick,
    onLoginClick,
    candidateSelectedExperience,

    onCandidateJobsFilterChange,
    checkSelectedTag,
    onCandidateFilterUnselectClick,
    onHandleSkillsReset,
    resetEmployment,
    resetExperience,

    candidateSelectedCountry,
    resetCountryFilter,
    onHandleClearAllFilter,
  } = useCandidateSuggestedJobs(props);

  return (
    <MainLayout activeMenuItem="jobs">
      <Container>
        <div className="search-box input-group border rounded bg-grey">
          <input
            type="text"
            className="form-control border-0 bg-transparent"
            placeholder="Search"
            onChange={(e) => onSearchInputChange(e)}
            ref={searchInputRef}
            style={{ height: "46px" }}
          />
          <div className="input-group-append">
            {showSearch ? (
              <button className="btn p-2" type="button" onClick={onSearch}>
                <FontAwesomeIcon icon={faDeleteLeft} className="ml-2" />
              </button>
            ) : (
              <button className="btn p-2" type="button">
                <img src="../assets/images/search-icon.png" alt="search" />
              </button>
            )}
          </div>
        </div>
        <div className="text-right ml-3">
          {!userMetaData ? (
            // <button
            //   className="btn btn-primary h-100"
            //   onClick={onViewAppliedJobsClick}
            // >
            //   View Applied Jobs
            // </button>
            <button className="btn btn-primary h-100" onClick={onLoginClick}>
              Log in
            </button>
          ) : null}
        </div>

        <div className="hiring-process-dashboard kanban-board-main mt-4">
          <ul className="my-4 nav nav-tabs" role="tablist">
            <li className="nav-item">
              <Link type="button" to="/job-board" className="nav-link">
                All Jobs
              </Link>
            </li>
            <li className="nav-item">
              <Link type="button" to="/all-applied-jobs" className="nav-link">
                Applied Jobs
              </Link>
            </li>
            <li className="nav-item">
              <Link
                type="button"
                to="/candidate-suggested-jobs"
                className="nav-link active"
              >
                Suggested Jobs
              </Link>
            </li>
          </ul>
          <div className="tab-content">
            <div role="tabpanel" className="fade tab-pane active show">
              <div className="row">
                <div className="col-lg-5">
                  <h3 className="mb-4">
                    Filters
                    {(Array.isArray(candidateSelectedCountry) &&
                      candidateSelectedCountry.length) ||
                    (Array.isArray(candidateSelectedEmployment) &&
                      candidateSelectedEmployment.length) ||
                    (Array.isArray(candidateSelectedExperience) &&
                      candidateSelectedExperience.length) ? (
                      <button
                        className="btn py-1 ml-3 btn-primary"
                        onClick={onHandleClearAllFilter}
                      >
                        Clear All Filter
                      </button>
                    ) : null}
                  </h3>
                  <div className="d-flex align-items-center mb-4 mr-3">
                    <div>
                      <Dropdown>
                        <Dropdown.Toggle
                          variant=""
                          className="border border-secondary bg-grey d-flex align-items-center"
                        >
                          Employment Type
                          {Array.isArray(candidateSelectedEmployment) &&
                          candidateSelectedEmployment?.length ? (
                            <span
                              className="bg-danger  rounded-circle ml-2 text-center"
                              style={{
                                height: "20px",
                                width: "20px",
                                fontSize: "10px",
                                lineHeight: "20px",
                              }}
                            >
                              {Array.isArray(candidateSelectedEmployment) &&
                                candidateSelectedEmployment?.length}
                            </span>
                          ) : null}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <ul className="px-3">
                            {EMPLOYMENT_TYPE &&
                              Array.isArray(EMPLOYMENT_TYPE) &&
                              EMPLOYMENT_TYPE?.map((item) => (
                                <>
                                  <li
                                    title={
                                      checkSelectedTag(
                                        item?.value,
                                        "employment"
                                      )
                                        ? "select"
                                        : "unselect"
                                    }
                                    className="d-flex py-2 text-nowrap align-items-center font-weight-semi cursor-pointer justify-content-between"
                                  >
                                    {item?.key}
                                    {checkSelectedTag(
                                      item?.value,
                                      "employment"
                                    ) ? (
                                      <button
                                        className="bg-transparent border-0 ml-3 text-danger position-relative"
                                        style={{ zIndex: 2 }}
                                        onClick={() =>
                                          onCandidateFilterUnselectClick(
                                            item?.value,
                                            "employment"
                                          )
                                        }
                                      >
                                        <FontAwesomeIcon icon={faXmark} />
                                      </button>
                                    ) : (
                                      <button
                                        className="bg-transparent rounded-lg ml-3 text-success border border-success position-relative"
                                        style={{ zIndex: 2 }}
                                        onClick={() =>
                                          onCandidateJobsFilterChange(
                                            item?.value,
                                            "employment"
                                          )
                                        }
                                      >
                                        Select
                                      </button>
                                    )}
                                  </li>
                                </>
                              ))}
                          </ul>
                          <div className="d-flex align-items-center border-top pt-2 px-3 justify-content-end">
                            <button
                              className="btn btn-dark py-1"
                              onClick={resetEmployment}
                            >
                              Reset
                            </button>
                          </div>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div className="ml-3">
                      <Dropdown>
                        <Dropdown.Toggle
                          variant=""
                          className="d-flex border border-secondary bg-grey align-items-center"
                        >
                          Experience
                          {Array.isArray(candidateSelectedExperience) &&
                          candidateSelectedExperience?.length ? (
                            <span
                              className="bg-danger  rounded-circle ml-2 text-center"
                              style={{
                                height: "20px",
                                width: "20px",
                                fontSize: "10px",
                                lineHeight: "20px",
                              }}
                            >
                              {Array.isArray(candidateSelectedExperience) &&
                                candidateSelectedExperience?.length}
                            </span>
                          ) : null}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <ul className="px-3">
                            {EXPERIENCE_TYPE &&
                              Array.isArray(EXPERIENCE_TYPE) &&
                              EXPERIENCE_TYPE?.map((item) => (
                                <>
                                  <li
                                    title={
                                      checkSelectedTag(
                                        item?.value,
                                        "experience"
                                      )
                                        ? "select"
                                        : "unselect"
                                    }
                                    className="d-flex py-2 text-nowrap align-items-center font-weight-semi cursor-pointer justify-content-between"
                                  >
                                    {item?.key}
                                    {checkSelectedTag(
                                      item?.value,
                                      "experience"
                                    ) ? (
                                      <button
                                        className="bg-transparent border-0 ml-3 text-danger position-relative"
                                        style={{ zIndex: 2 }}
                                        onClick={() =>
                                          onCandidateFilterUnselectClick(
                                            item?.value,
                                            "experience"
                                          )
                                        }
                                      >
                                        <FontAwesomeIcon icon={faXmark} />
                                      </button>
                                    ) : (
                                      <button
                                        className="bg-transparent rounded-lg ml-3 text-success border border-success position-relative"
                                        style={{ zIndex: 2 }}
                                        onClick={() =>
                                          onCandidateJobsFilterChange(
                                            item?.value,
                                            "experience"
                                          )
                                        }
                                      >
                                        Select
                                      </button>
                                    )}
                                  </li>
                                </>
                              ))}
                          </ul>
                          <div className="d-flex align-items-center border-top pt-2 px-3 justify-content-end">
                            <button
                              className="btn btn-dark py-1"
                              onClick={resetExperience}
                            >
                              Reset
                            </button>
                          </div>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div className="ml-3">
                      <Dropdown>
                        <Dropdown.Toggle
                          variant=""
                          className="d-flex border border-secondary bg-grey align-items-center"
                        >
                          Country
                          {Array.isArray(candidateSelectedCountry) &&
                          candidateSelectedCountry?.length ? (
                            <span
                              className="bg-danger  rounded-circle ml-2 text-center"
                              style={{
                                height: "20px",
                                width: "20px",
                                fontSize: "10px",
                                lineHeight: "20px",
                              }}
                            >
                              {Array.isArray(candidateSelectedCountry) &&
                                candidateSelectedCountry?.length}
                            </span>
                          ) : null}
                        </Dropdown.Toggle>
                        <Dropdown.Menu style={{ minWidth: "200px" }}>
                          <div className="p-2">
                            <CountrySearchDropdown
                              searchStyle={{ width: "100%" }}
                              placeholder="Country"
                              onSearchSelect={(e) =>
                                onCandidateJobsFilterChange(e.name, "country")
                              }
                              defaultCountryValue={"Type Country Name..."}
                            />

                            <div className="d-flex d-flex mt-3 align-items-center flex-wrap">
                              {Array.isArray(candidateSelectedCountry) &&
                                candidateSelectedCountry?.map((item) => (
                                  <div className="h4 py-1 text-capitalize border rounded-pill font-weight-normal cursor-pointer bg-primary-light border-primary text-primary px-2 mr-2 text-capitalize d-flex">
                                    {item}
                                    <button
                                      onClick={() =>
                                        onCandidateFilterUnselectClick(
                                          item,
                                          "country"
                                        )
                                      }
                                      className="bg-transparent border-0 position-relative"
                                      style={{ zIndex: 2 }}
                                    >
                                      <FontAwesomeIcon icon={faXmark} />
                                    </button>
                                  </div>
                                ))}
                            </div>

                            <div className="d-flex mt-3 align-items-center border-top pt-2 px-3 justify-content-end">
                              <button
                                className="btn btn-dark py-1"
                                onClick={resetCountryFilter}
                              >
                                Reset
                              </button>
                            </div>
                          </div>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>

                <div className="col-lg-7">
                  <h3 className="mb-4">
                    Filter By Skills
                    {Array.isArray(candidateSelectedSkill) &&
                    candidateSelectedSkill &&
                    candidateSelectedSkill.length ? (
                      <button
                        className="btn py-1 ml-3 btn-primary"
                        onClick={onHandleSkillsReset}
                      >
                        Clear All
                      </button>
                    ) : null}
                  </h3>
                  <Swiper
                    slidesPerView={"auto"}
                    spaceBetween={5}
                    modules={[FreeMode, Navigation]}
                    className="custom-tab-slider"
                    navigation={true}
                    loop={true}
                  >
                    {skillsTagsAdded &&
                      Array.isArray(skillsTagsAdded) &&
                      skillsTagsAdded.map((tag, index) => (
                        <SwiperSlide>
                          <div
                            className={`h4 py-1 border rounded-pill font-weight-normal cursor-pointer ${
                              checkSelectedTag(tag?.skill, "skill")
                                ? "bg-primary-light border-primary text-primary"
                                : "text-grey-4 bg-white"
                            } px-2 mr-2 text-capitalize d-flex`}
                            key={index}
                          >
                            <div
                              onClick={() =>
                                onCandidateJobsFilterChange(tag?.skill, "skill")
                              }
                              className="d-flex flex-wrap pr-1"
                            >
                              {tag?.skill}
                            </div>
                            {checkSelectedTag(tag?.skill, "skill") ? (
                              <button
                                className="bg-transparent border-0 position-relative"
                                style={{ zIndex: 2 }}
                                onClick={() =>
                                  onCandidateFilterUnselectClick(
                                    tag?.skill,
                                    "skill"
                                  )
                                }
                              >
                                <FontAwesomeIcon icon={faXmark} />
                              </button>
                            ) : null}
                          </div>
                        </SwiperSlide>
                      ))}
                  </Swiper>
                </div>
              </div>

              <div className="hiring-process-dashboard row no-gutters">
                <div className="col-md-12 col-lg-12 col-xl-12">
                  {loading ? (
                    <div className="d-flex justify-content-center align-items-center">
                      <Spinner animation="border" variant="primary" />
                    </div>
                  ) : Array.isArray(allJobs) &&
                    allJobs &&
                    allJobs.length > 0 ? (
                    <div className="mt-4 mt-md-0">
                      <div className="d-flex align-items-end justify-content-between mb-3">
                        <h2 className="d-inline-block mb-2">
                          {" "}
                          Showing {Array.isArray(allJobs) &&
                            allJobs.length}{" "}
                          Jobs
                        </h2>
                      </div>

                      <div className="job-listing">
                        <div className="row">
                          {Array.isArray(allJobs) &&
                            allJobs.map((data, index) => (
                              <JobCard
                                jobItem={data}
                                setLastElement={setLastElement}
                                onJobApplyClick={onJobApplyClick}
                                index={index}
                              />
                            ))}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="msg-bg text-white p-3 border-6 m-t-75 d-flex align-items-center justify-content-center mb-2 mw-50 mx-auto">
                      <p className="mb-0">
                        <FontAwesomeIcon
                          icon={faCircleInfo}
                          className="text-white mr-2"
                        />
                        {userMetaData ? "No Jobs Found" : "Log in to explore"}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </MainLayout>
  );
}
